import { render, staticRenderFns } from "./KonfigNotenuebersichtModal.vue?vue&type=template&id=9171a7d2"
import script from "./KonfigNotenuebersichtModal.vue?vue&type=script&lang=js"
export * from "./KonfigNotenuebersichtModal.vue?vue&type=script&lang=js"
import style0 from "./KonfigNotenuebersichtModal.vue?vue&type=style&index=0&id=9171a7d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports